module.exports = __webpack_public_path__ + "img/icon-r-compare-active.c65a981c.svg";